// src/App.js
import React, { useState } from "react";
import Auth from "./Auth";
import CardScanner from "./CardScanner";
import HistoryView from "./HistoryView";
import QRGenerator from "./QRGenerator";
import QRScanner from "./QRScanner";
import "./App.css";

function App() {
    const [activeTab, setActiveTab] = useState('scanner');
    const [showQRGenerator, setShowQRGenerator] = useState(false);
    const [showQRScanner, setShowQRScanner] = useState(false);

    return (
        <div className="App">
            <Auth>
                <div className="tabs">
                    <button 
                        onClick={() => setActiveTab('scanner')} 
                        className={activeTab === 'scanner' ? 'active' : ''}
                    >
                        掃描名片
                    </button>
                    <button 
                        onClick={() => setActiveTab('history')} 
                        className={activeTab === 'history' ? 'active' : ''}
                    >
                        歷史紀錄
                    </button>
                    <button 
                        onClick={() => setShowQRGenerator(true)} 
                        className="qr-btn"
                    >
                        電子名片 QR
                    </button>
                    <button 
                        onClick={() => setShowQRScanner(true)} 
                        className="qr-scan-btn"
                    >
                        掃描 QR 名片
                    </button>
                </div>
                
                {activeTab === 'scanner' && <CardScanner />}
                {activeTab === 'history' && <HistoryView />}
                
                {showQRGenerator && (
                    <QRGenerator onClose={() => setShowQRGenerator(false)} />
                )}
                
                {showQRScanner && (
                    <QRScanner onClose={() => setShowQRScanner(false)} />
                )}
                
                <style jsx="true">{`
                    .tabs {
                        display: flex;
                        background: rgba(255, 255, 255, 0.2);
                        backdrop-filter: blur(20px);
                        border-bottom: 1px solid rgba(255,255,255,0.3);
                        position: sticky;
                        top: 0;
                        z-index: 10;
                        border-radius: 20px 20px 0 0;
                    }

                    .tabs button {
                        flex: 1;
                        padding: 18px 24px;
                        border: none;
                        background: transparent;
                        cursor: pointer;
                        font-size: 16px;
                        font-weight: 600;
                        color: rgba(108, 99, 143, 0.8);
                        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                        position: relative;
                        overflow: hidden;
                        border-radius: 16px;
                        margin: 8px 4px;
                    }

                    .tabs button::before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        background: linear-gradient(135deg, rgba(63, 81, 181, 0.1), rgba(103, 58, 183, 0.08));
                        opacity: 0;
                        transition: opacity 0.3s ease;
                        border-radius: 16px;
                    }

                    .tabs button:hover::before {
                        opacity: 1;
                    }

                    .tabs button:hover {
                        color: rgba(108, 99, 143, 1);
                        transform: translateY(-2px);
                        box-shadow: 0 8px 25px rgba(63, 81, 181, 0.3);
                    }

                    .tabs button.active {
                        color: rgba(108, 99, 143, 1);
                        background: rgba(255, 255, 255, 0.4);
                        backdrop-filter: blur(10px);
                        border: 1px solid rgba(255, 255, 255, 0.6);
                        box-shadow: 
                            0 8px 32px rgba(31, 38, 135, 0.37),
                            inset 0 1px 0 rgba(255, 255, 255, 0.5);
                        transform: translateY(-1px);
                    }

                    .tabs button.active::before {
                        opacity: 0;
                    }

                    .qr-btn {
                        background: linear-gradient(135deg, #ff6b6b 0%, #feca57 100%) !important;
                        color: white !important;
                        border: none !important;
                        box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3) !important;
                        font-weight: 600;
                        margin-left: 8px;
                        position: relative;
                        overflow: hidden;
                    }


                    .qr-btn:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 6px 20px rgba(255, 107, 107, 0.4) !important;
                        background: linear-gradient(135deg, #ff5252 0%, #ffc107 100%) !important;
                    }

                    .qr-scan-btn {
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
                        color: white !important;
                        border: none !important;
                        box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3) !important;
                        font-weight: 600;
                        margin-left: 8px;
                        position: relative;
                        overflow: hidden;
                    }


                    .qr-scan-btn:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
                        background: linear-gradient(135deg, #5a6fd8 0%, #6b4b9a 100%) !important;
                    }

                    /* 移動端優化 */
                    @media (max-width: 768px) {
                        .tabs button {
                            padding: 14px 16px;
                            font-size: 14px;
                        }
                    }
                `}</style>
            </Auth>
        </div>
    );
}

export default App;
